import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../Auth/useUser";

const CaissierRoute = ({ children }) => {
  const user = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return user.result.role === "caissier" ||
    user.result.role === "serveur" ||
    user.result.role === "admin" ? (
    children
  ) : (
    <Navigate to="/login" replace />
  );
};

export default CaissierRoute;
